export default __webpack_public_path__ + "static/media/esmasultaniki1.34fe91fc.jpg";